import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import StoreIcon from "@mui/icons-material/Store";
import RestaurantIcon from "@mui/icons-material/Restaurant";
import { store } from "../../shared";
import { setRestaurant } from "../../shared/slice/restaurant/RestaurantSlice";
import { useLocation } from "react-router-dom";
import ModalDelivery from "../Modals/ModalDelivery";
import { getcompanybyid } from "../../shared/slice/company/CompanyService";
import { getstorebyidcompany } from "../../shared/slice/restaurant/RestaurantService";
import { setModesModal } from "../../shared/slice/ModalMode/ModalMode";
import { setStoresModal } from "../../shared/slice/ModalStores/ModalStores";
import { useTranslation } from "react-i18next";
export default function StoreNavbar() {
  const dispatch = useDispatch();

  const restaurantSelected = useSelector(
    (state) => state.restaurant.restaurantSelected
  );

  const modeName = useSelector((state) => state.restaurant.modeName);
  const [Company, setCompany] = useState([]);
  const location = useLocation();
  const { t } = useTranslation();
  const { delivery } = location.state || {};
  useEffect(() => {
    const fetchCompanyByName = async () => {
      try {
        const res = await getcompanybyid(restaurantSelected.companyId);
        if (res.length > 0) {
          const storeRes = await getstorebyidcompany(
            restaurantSelected.companyId
          );
          setCompany(storeRes);
          dispatch(setRestaurant({ restaurant: storeRes.stores }));
        } else {
          // navigate(`/page404`);
        }
      } catch (err) {
        console.error("Error fetching company by ID:", err);
      }
    };
    fetchCompanyByName();
  }, [restaurantSelected]);
  const address = restaurantSelected.address;
  const maxLength = 40;
  const storeSelector = (
    <>
      <ModeButton
        onClick={() => {
          if (delivery === undefined && Company?.stores?.length > 1) {
            dispatch(setStoresModal({ storesModal: true }));
          }
        }}
        data-testid="mode_pavarottis"
      >
        {restaurantSelected.name}
        <p style={{ fontSize: "0.7rem", color: "#212121", padding: "0px" }}>
          {restaurantSelected.detailedAddress?.house_number &&
          restaurantSelected.detailedAddress?.road &&
          restaurantSelected.detailedAddress?.city &&
          restaurantSelected.detailedAddress?.postcode
            ? `${restaurantSelected.detailedAddress.house_number} ${restaurantSelected.detailedAddress.road}, ${restaurantSelected.detailedAddress.postcode} ${restaurantSelected.detailedAddress.city}`
            : restaurantSelected.address}
        </p>
      </ModeButton>
    </>
  );
  const modeSelector = (
    <>
      <ModeButtons
        onClick={() => {
          store.dispatch(setModesModal({ modesModal: true }));
        }}
        data-testid="mode"
      >
        {t(modeName)}
      </ModeButtons>
    </>
  );

  return (
    <NavbarContainer>
      <StoreNavItem>
        <NavLink>
          <IconWrapper>
            <StoreIcon />
            {storeSelector}
          </IconWrapper>
        </NavLink>
      </StoreNavItem>
      <ModeNavItem>
        <NavLink>
          <IconWrapper2>
            <RestaurantIcon />
            {modeSelector}
          </IconWrapper2>
          <ModalDelivery />
        </NavLink>
      </ModeNavItem>
    </NavbarContainer>
  );
}

const NavLink = styled.div`
  text-decoration: none;
`;

const ModeButton = styled.button`
  padding: 4px;
  border-radius: 15px;
  background-color: #fff;
  color: var(--primaryColor);
  font-size: 14px;
  cursor: pointer;
  padding-right: 0px;
  width: 450px;
  height: 42px;
  @media (max-width: 768px) {
    max-width: 97%;
    line-height: 80%;
    font-size: 0.7rem;
  }
`;
const ModeButtons = styled.button`
  padding: 4px;
  height: 42px;
  font-size: 16px;
  border-radius: 15px;
  background-color: #fff;
  color: var(--primaryColor);
  cursor: pointer;
  padding-right: 2px;
  width: 150px;

  @media (min-width: 540px) and (max-width: 768px) {
    width: 100%;
    max-width: 97%;
  }

  @media (max-width: 385px) {
    width: 100%;
    max-width: 97%;
    font-size: 0.8rem !important;
  }
`;



const NavbarContainer = styled.div`
  display: flex;
  justify-content: center;
  position: sticky;
  top: 54px;
  z-index: 1000;
  background: #fff;
  margin-left: 15%;
  padding: 15px;

  @media (max-width: 768px) {
    margin-left: 0;
    justify-content: space-between;
  }
`;

const StoreNavItem = styled.div`
  @media (max-width: 768px) {
    width: 63%;
  }
`;

const ModeNavItem = styled.div`
  @media (max-width: 768px) {
    width: 36%;
  }
`;

const IconWrapper = styled.span`
  display: flex;
  align-items: center;
  color: var(--secondaryColor);
  border: 2px solid var(--primaryColor);
  border-radius: 20px;
  background: var(--primaryColor);
  margin-right: 10px;
`;
const IconWrapper2 = styled.span`
  display: flex;
  align-items: center;
  color: var(--secondaryColor);
  border: 2px solid var(--primaryColor);
  border-radius: 20px;
  background: var(--primaryColor);
  margin-right: 10px;
`;
